/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TranslationSearchOrderByPaginationQuery } from './TranslationSearchOrderByPaginationQuery';
import {
    TranslationSearchOrderByPaginationQueryFromJSON,
    TranslationSearchOrderByPaginationQueryFromJSONTyped,
    TranslationSearchOrderByPaginationQueryToJSON,
    TranslationSearchOrderByPaginationQueryToJSONTyped,
} from './TranslationSearchOrderByPaginationQuery';

/**
 * 
 * @export
 * @interface TranslationsSearchRequest
 */
export interface TranslationsSearchRequest {
    /**
     * 
     * @type {TranslationSearchOrderByPaginationQuery}
     * @memberof TranslationsSearchRequest
     */
    paginationQuery?: TranslationSearchOrderByPaginationQuery;
}

/**
 * Check if a given object implements the TranslationsSearchRequest interface.
 */
export function instanceOfTranslationsSearchRequest(value: object): value is TranslationsSearchRequest {
    return true;
}

export function TranslationsSearchRequestFromJSON(json: any): TranslationsSearchRequest {
    return TranslationsSearchRequestFromJSONTyped(json, false);
}

export function TranslationsSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TranslationsSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationQuery': json['paginationQuery'] == null ? undefined : TranslationSearchOrderByPaginationQueryFromJSON(json['paginationQuery']),
    };
}

export function TranslationsSearchRequestToJSON(json: any): TranslationsSearchRequest {
    return TranslationsSearchRequestToJSONTyped(json, false);
}

export function TranslationsSearchRequestToJSONTyped(value?: TranslationsSearchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationQuery': TranslationSearchOrderByPaginationQueryToJSON(value['paginationQuery']),
    };
}

